import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../../providers/auth0-instance";
import { withErrorNotification } from "../notifications";
import { patchDetectionRequest, Detection } from "../../types";

export const detectionApi = createApi({
  reducerPath: "detectionApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["Detection"],
  endpoints: (builder) => ({
    patchDetection: builder.mutation<Detection, patchDetectionRequest>({
      query: ({ id, data }) => ({
        url: `/detection/${id}`,
        method: "PATCH",
        data,
      }),
      invalidatesTags: ["Detection"],
      onQueryStarted: withErrorNotification("Failed to update specimen"),
    }),
  }),
});

export const { usePatchDetectionMutation } = detectionApi;
